import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export const Lightbox = ({ items, index, onClose, onNav }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNav(1);
      if (e.key === "ArrowLeft") onNav(-1);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, onNav]);

  return (
    <AnimatePresence>
      {index !== null && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="fixed inset-0 z-[60] flex items-center justify-center bg-ink-950/95 p-4 sm:p-10"
          onClick={onClose}
          data-testid="lightbox-overlay"
        >
          <button
            onClick={onClose}
            data-testid="lightbox-close"
            aria-label="Kapat"
            className="absolute right-5 top-5 text-cream-50/70 transition-colors hover:text-cream-50"
          >
            <X size={28} />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); onNav(-1); }}
            data-testid="lightbox-prev"
            aria-label="Önceki"
            className="absolute left-3 top-1/2 -translate-y-1/2 p-3 text-cream-50/70 transition-colors hover:text-cream-50 sm:left-6"
          >
            <ChevronLeft size={34} />
          </button>
          <motion.img
            key={items[index].src}
            src={items[index].src}
            alt={items[index].alt}
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.35 }}
            className="max-h-[82vh] max-w-full object-contain"
            onClick={(e) => e.stopPropagation()}
            data-testid="lightbox-image"
          />
          <button
            onClick={(e) => { e.stopPropagation(); onNav(1); }}
            data-testid="lightbox-next"
            aria-label="Sonraki"
            className="absolute right-3 top-1/2 -translate-y-1/2 p-3 text-cream-50/70 transition-colors hover:text-cream-50 sm:right-6"
          >
            <ChevronRight size={34} />
          </button>
          <p className="absolute bottom-5 left-1/2 -translate-x-1/2 text-xs font-medium uppercase tracking-[0.2em] text-cream-50/60">
            {index + 1} / {items.length} — {items[index].alt}
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
